// header.component.ts
import { Component, computed, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Menubar } from 'primeng/menubar';
import { MenuItem, PrimeTemplate } from 'primeng/api';
import { InputText } from 'primeng/inputtext';
import { ButtonDirective } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { IndexIoService } from '../../services/index-io.service';
import { DarkModeService } from '../../services/dark-mode.service';

@Component({
  selector: 'bnpp-indx-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    Menubar,
    PrimeTemplate,
    InputText,
    ButtonDirective,
    FormsModule,
  ],
  standalone: true,
})
export class HeaderComponent implements OnInit {
  menuItems: MenuItem[] = [];
  searchTerm: string = '';
  private indexInfoService = inject(IndexIoService);
  private darkModeService = inject(DarkModeService);
  public deployUrlHost = this.indexInfoService.getDeployUrlHost();
  protected logoUrl = computed(() => {
    const isDarkMode = this.darkModeService.isDarkMode();
    return isDarkMode ? `${this.deployUrlHost}/assets/LogoBNPParibas_Large.jpg` : `${this.deployUrlHost}/assets/logo-bnp.png`
  });
  constructor(private router: Router) { }

  ngOnInit() {
    this.menuItems = [
      { label: 'HOME', routerLink: '/' },
      { label: 'INDEX RESOURCES', routerLink: '/index-resources' },
      { label: 'brio', routerLink: '/brio' },
      { label: 'ABOUT US', routerLink: '/about' },
      { label: 'CONTACT US', routerLink: '/contact' },
    ];
  }

  onSearch() {
    this.router.navigate(['/search'], {
      queryParams: { term: this.searchTerm },
    });
    this.searchTerm = '';
  }
}
